// Vendor şirket ayarları + ödeme sağlayıcı + branding
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { Button, FormField, ListPageHeader } from '../components/ui';

export default function VendorSettingsPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    api.get('/vendor/settings').then(r => {
      setData(r.data.data || {});
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/vendor/settings', data);
      setMsg({ type:'success', text:'Kaydedildi' });
    } catch (err) { setMsg({ type:'error', text: err.response?.data?.message || 'Hata' }); }
    setSaving(false);
    setTimeout(() => setMsg(null), 3000);
  };

  const f = (k, v) => setData(p => ({ ...p, [k]: v }));

  if (loading) return <div style={{ padding: 40 }}>Yükleniyor...</div>;

  return (
    <div className="stocks-page">
      <ListPageHeader title="Vendor Ayarları" subtitle="HENT'in kendi şirket bilgileri ve sistem ayarları" />
      <div style={{ padding: 18, maxWidth: 800 }}>
        {msg && (
          <div style={{ marginBottom: 14, padding:'8px 12px', borderRadius:6,
                        background: msg.type === 'error' ? 'rgba(239,68,68,0.10)' : 'rgba(16,185,129,0.10)',
                        color: msg.type === 'error' ? '#b91c1c' : '#059669', fontSize:'0.85rem' }}>{msg.text}</div>
        )}

        <Card title="🏢 Şirket Bilgileri">
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(240px, 1fr))', gap: 12 }}>
            <FormField label="Ünvan"><input className="ui-input" value={data.name || ''} onChange={e => f('name', e.target.value)} /></FormField>
            <FormField label="Kod"><input className="ui-input" value={data.code || ''} disabled /></FormField>
            <FormField label="Vergi No"><input className="ui-input" value={data.tax_number || ''} onChange={e => f('tax_number', e.target.value)} /></FormField>
            <FormField label="Vergi Dairesi"><input className="ui-input" value={data.tax_office || ''} onChange={e => f('tax_office', e.target.value)} /></FormField>
            <FormField label="E-posta"><input className="ui-input" type="email" value={data.email || ''} onChange={e => f('email', e.target.value)} /></FormField>
            <FormField label="Telefon"><input className="ui-input" value={data.phone || ''} onChange={e => f('phone', e.target.value)} /></FormField>
            <FormField label="Şehir"><input className="ui-input" value={data.city || ''} onChange={e => f('city', e.target.value)} /></FormField>
          </div>
          <FormField label="Adres"><textarea className="ui-input" value={data.address || ''} onChange={e => f('address', e.target.value)} rows={2} /></FormField>
          <div style={{ display:'flex', justifyContent:'flex-end', marginTop: 12 }}>
            <Button variant="primary" onClick={save} disabled={saving}>{saving ? '...' : 'Kaydet'}</Button>
          </div>
        </Card>

        <Card title="💳 Ödeme Sağlayıcı" sub="Env değişkenlerinden okunur — şu an aktif olan görüntüleniyor">
          <div style={{ fontSize:'0.85rem', color:'var(--text-secondary)', padding:'8px 0' }}>
            Aktif sağlayıcı: <strong>{process.env.REACT_APP_PAYMENT_PROVIDER || 'iyzico'}</strong>
            <div style={{ marginTop: 8, fontSize:'0.78rem', color:'var(--text-tertiary)' }}>
              Iyzico veya PayTR API key'leri sunucu env dosyasında yapılandırılır. Frontend'den değiştirilemez.
            </div>
          </div>
        </Card>

        <Card title="📧 SMTP (Müşteri Mesajları için)" sub="Vendor şirketin SMTP yapılandırması — Ayarlar → SMTP sekmesinden">
          <div style={{ fontSize:'0.82rem', color:'var(--text-secondary)' }}>
            SMTP ayarları normal "Ayarlar" sayfasında bu vendor şirketi için yapılandırılır.
            Müşteri mesajları broadcast'ları o yapılandırma ile gönderilir.
          </div>
        </Card>

        <Card title="🎨 Branding (yakında)">
          <div style={{ fontSize:'0.82rem', color:'var(--text-tertiary)' }}>Logo, ana renk, fatura şablonu özelleştirmesi — Faz 5'te</div>
        </Card>
      </div>
    </div>
  );
}

function Card({ title, sub, children }) {
  return (
    <div style={{ background:'var(--bg-secondary)', border:'1px solid var(--border-secondary)', borderRadius: 8, marginBottom: 14 }}>
      <div style={{ padding:'12px 16px', borderBottom:'1px solid var(--border-secondary)' }}>
        <div style={{ fontSize:'0.95rem', fontWeight:600 }}>{title}</div>
        {sub && <div style={{ fontSize:'0.74rem', color:'var(--text-tertiary)', marginTop: 2 }}>{sub}</div>}
      </div>
      <div style={{ padding: 16 }}>{children}</div>
    </div>
  );
}
